/**
 * Frontside View
 */

import { useBlockProps } from '@wordpress/block-editor';

export default function save({ attributes }) {
     const { images, slidesPerView, speed, autoplay, loop, navigation, pagination } = attributes;

     return (
        <div
            {...useBlockProps.save({
                className: 'custom-slider',
            
                /**
 * Add data attributes for JS initialization
 */
                'data-slides': slidesPerView,
                'data-speed': speed,
                'data-autoplay': autoplay,
                'data-loop': loop,
                'data-navigation': navigation,
                'data-pagination': pagination,
            })}
        >
            {images?.length ? (
                <div className="swiper">
                    <div className="swiper-wrapper">
                        {images.map((img) => (
                            <div className="swiper-slide" key={img.id}>
                                <img src={img.url} alt={img.alt} />
                            </div>
                        ))}
                    </div>

                    {/* Show navigation and pagination only if enabled */}
                    {navigation && (
                        <>
                            <div className="swiper-button-prev"></div>
                            <div className="swiper-button-next"></div>
                        </>
                    )}
                    {pagination && <div className="swiper-pagination"></div>}
                </div>
            ) : (
                <p>No images selected yet.</p>
            )}
        </div>
    );
}